<template>
  <div>
    <AppDataProperty
      contentId="addresses"
      @dataAvailable="
        data => {
          appData = data
        }
      "
      isComponent
    />
    <ModalComponent
      ref="modal"
      headerBg="#fff"
      class="[&_.boxComponent]:w-full [&_.boxComponent]:md:w-[450px]"
      :onPrimaryClick="
        () => {
          submitRating()
        }
      "
    >
      <template #header>
        <div></div>
      </template>

      <div class="w-full h-full">
        <div class="font-bold text-3xl text-center">
          {{ $t('rating.title') }}
        </div>
        <div class="py-1"></div>
        <div class="title-description-color text-center">
          {{ $t('rating.description') }}
        </div>
        <div class="py-4"></div>
        <div class="w-full h-[50px] relative">
          <div class="absolute w-full h-full pointer-events-none opacity-20">
            <div class="w-full flex h-full justify-around items-center">
              <div
                v-for="(i, key) in [0, 0, 0, 0, 0]"
                :key="key"
                class="h-full"
              >
                <img
                  src="@/assets/images/all/star.svg"
                  alt=""
                  class="w-full h-full"
                />
              </div>
            </div>
          </div>
          <div class="absolute w-full h-full pointer-events-none">
            <div
              class="w-full flex h-full justify-around items-center"
              :style="{ '--ratePercent': ratePercent + '%' }"
              style="
                mask-image: linear-gradient(
                  to right,
                  black 0%,
                  black var(--ratePercent),
                  transparent var(--ratePercent)
                );
              "
            >
              <div
                v-for="(i, key) in [0, 0, 0, 0, 0]"
                :key="key"
                class="h-full"
              >
                <img
                  src="@/assets/images/all/star.svg"
                  alt=""
                  class="w-full h-full"
                />
              </div>
            </div>
          </div>
          <div class="w-full h-full opacity-0">
            <div class="-mx-4 h-full -my-4">
              <input
                v-model="rate"
                type="range"
                min="0"
                max="5"
                step="0.5"
                class="w-full h-full"
              />
            </div>
          </div>
        </div>
        <div class="py-4"></div>
        <div class="text-5xl text-center">
          {{ rateText }}
        </div>
        <div class="py-2"></div>
        <div>
          <div
            :class="{
              'h-0': !rateCommentIsVisible,
              'h-[100px]': rateCommentIsVisible,
            }"
          >
            <textarea
              class="h-full border rounded-xl w-full p-1"
              placeholder="Dites-nous en plus"
              v-model="comment"
            >
            </textarea>
          </div>
        </div>
      </div>

      <template #primaryButton>
        {{ $t('rating.sendRateButton') }}
      </template>
      <template #cancelButton>
        {{ $t('rating.cancelRattingButton') }}
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '../utils/ModalComponent.vue'
import AppDataProperty from '../appData/AppDataProperty.vue'

export default defineComponent({
  name: 'TransactionDetailsComponent',
  components: { ModalComponent, AppDataProperty },
  props: {},
  data() {
    return {
      reference: '',
      eventsIds: [],
      appData: {},
      rate: 5,
      rateCommentIsVisible: false,
      comment: '',
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'single_transaction_updated',
      this.onTransactionUpdated,
    )
    // const id2 = this.$Events.handleEvent(
    //   "app_data_updated",
    //   this.showAppRatingWitoutForce
    // );
    const id3 = this.$Events.handleEvent(
      'start_rating',
      this.showAppRatingForce,
    )
    this.eventsIds.push(id)
    // this.eventsIds.push(id2);
    this.eventsIds.push(id3)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    onTransactionUpdated(transaction) {
      const isSuccessTransaction = this.checkIsSuccess(transaction)
      if (!isSuccessTransaction) return
      this.showAppRatingWitoutForce()
    },
    checkIsSuccess(transaction) {
      const isSuccess = transaction.status == 'success'
      return isSuccess
    },
    showAppRatingWitoutForce() {
      this.showAppRating()
    },
    showAppRatingForce() {
      this.showAppRating(true)
    },
    showAppRating(force) {
      const onceRated = this.$QuickStorage.getStored('onceRated')
      if (onceRated && !force) return
      this.rateCommentIsVisible = false
      this.rate = 5
      this.comment = ''
      this.$refs.modal.show()
    },
    submitRating() {
      if (this.rate >= 3) {
        this.$Events.dispatchEvent('url_opening_required', {
          url:
            (this.appData?.metaData?.ratingUrl ||
              'https://play.google.com/store/apps/details?id=com.lacasaegroup.onebpay') +
            '&date=' +
            Date.now(),
          title: this.$t('rating.playStoreRedirectionText'),
        })
        this.$QuickStorage.storeData('onceRated', true)
      } else {
        this.$Events.dispatchEvent('url_opening_required', {
          url:
            this.appData?.metaData?.whatsappComplaintLink +
            '?date=' +
            Date.now(),
          title: this.$t('rating.whatsappRedirectionText'),
        })
      }
    },
  },
  computed: {
    ratePercent() {
      return (this.rate * 100) / 5
    },
    rateText() {
      if (this.rate <= 0) return '😭'
      if (this.rate <= 1) return '😢'
      if (this.rate <= 2) return '🙁'
      if (this.rate <= 3) return '😑'
      if (this.rate <= 4) return '🙂'
      return '😍'
    },
  },
})
</script>
